import Projects from './steps/Projects';
import DataImport from './steps/DataImport';
import ColumnValidation from './steps/ColumnValidation';
import DataImportSummary from './steps/DataImportSummary';
import Visualization from './steps/Visualization';
import ModelEvaluation from './steps/ModelEvaluation';
import Normalization from './steps/Normalization';
import ModelTraining from './steps/ModelTraining';
import Tendencies from './steps/Tendencies';

export const appSteps = [
  'projects',
  'dataimport',
  'columnvalidation',
  'importsummary',
  'visualization',
  'modeltraining',
  'modelevaluation',
  'normalization',
  'tendencies',
];

export function wasStepAlreadyCompleted(step, lastCompletedStep) {
  return (
    lastCompletedStep &&
    step &&
    appSteps.indexOf(lastCompletedStep) >= appSteps.indexOf(step)
  );
}

export const stepComponentMapping = {
  projects: Projects,
  dataimport: DataImport,
  columnvalidation: ColumnValidation,
  importsummary: DataImportSummary,
  visualization: Visualization,
  modeltraining: ModelTraining,
  modelevaluation: ModelEvaluation,
  normalization: Normalization,
  tendencies: Tendencies,
};
export const tabs = [
  {
    name: 'Projekty',
    steps: ['projects'],
    id: 'projects',
  },
  {
    name: 'Import Danych',
    steps: ['dataimport', 'columnvalidation', 'importsummary'],
    id: 'dataimport',
  },
  {
    name: 'Wizualizacja',
    steps: ['visualization'],
    id: 'visualization',
  },
  {
    name: 'Trening Modelu',
    steps: ['modeltraining'],
    id: 'modeltraining',
  },
  {
    name: 'Ocena Modelu',
    steps: ['modelevaluation'],
    id: 'modelevaluation',
  },
  {
    name: 'Normalizacja',
    steps: ['normalization'],
    id: 'normalization',
  },
  {
    name: 'Tendencje',
    steps: ['tendencies'],
    id: 'tendencies',
  },
];

export const getActiveTab = (visibleStep) => {
  return tabs.find(({ steps }) => steps.includes(visibleStep));
};
export const getEnabledTabs = (tabs, lastCompletedStep) => {
  if (!lastCompletedStep) {
    return [tabs[0].id];
  }
  // testing purpose - enable all
  // return tabs.map(({ id }) => id);
  if (
    ['projects', 'dataimport', 'columnvalidation'].includes(lastCompletedStep)
  ) {
    return [tabs[0].id, tabs[1].id];
  }
  if (['importsummary', 'visualization'].includes(lastCompletedStep)) {
    return [tabs[0].id, tabs[1].id, tabs[2].id, tabs[3].id];
  }
  if (['modeltraining', 'modelevaluation'].includes(lastCompletedStep)) {
    return [
      tabs[0].id,
      tabs[1].id,
      tabs[2].id,
      tabs[3].id,
      tabs[4].id,
      tabs[5].id,
    ];
  }
  if (['normalization', 'tendencies'].includes(lastCompletedStep)) {
    return [
      tabs[0].id,
      tabs[1].id,
      tabs[2].id,
      tabs[3].id,
      tabs[4].id,
      tabs[5].id,
      tabs[6].id,
    ];
  }
};
export const getLastCompletedStep = (projectStepsData) => {
  if (!projectStepsData) {
    return null;
  }

  let lastCompleted = null;
  for (let step of appSteps) {
    const stepData = projectStepsData.find((s) => s.name == step);
    if (stepData?.status == 'completed') {
      lastCompleted = step;
    }
  }
  return lastCompleted;
};
export const getNextStep = (step) => {
  const current = appSteps.findIndex((s) => s == step);
  if (current == -1) {
    throw new Error(`Step: ${step} not found`);
  }
  const nextStep = appSteps[current + 1];
  if (nextStep === undefined) {
    throw new Error(`No newer steps`);
  }

  return nextStep;
};
export const getPreviousStep = (step) => {
  const current = appSteps.findIndex((s) => s == step);
  if (current == -1) {
    throw new Error(`Step: ${step} not found`);
  }
  const previousStep = appSteps[current - 1];
  if (previousStep === undefined) {
    throw new Error(`No newer steps`);
  }

  return previousStep;
};
export const getStepsFurtherThan = (step) => {
  return appSteps.filter(
    (appStep) => appSteps.indexOf(appStep) > appSteps.indexOf(step),
  );
};
/**
 * return True if step is further then step2
 */
export const isStepFurtherThan = (step, step2) => {
  if (appSteps.indexOf(step) < 0 || appSteps.indexOf(step2) < 0) {
    throw new Error(
      'cannot determine which step is further. one of the steps not found.',
    );
  }
  return appSteps.indexOf(step) > appSteps.indexOf(step2);
};
/*
  Return data for a step with a given name from list of steps.

  for example:

  stepName = 'dataimport'
  steps = [
    { name: 'x', data: { foo: bar }},
    { name: 'dataimport', data: { foo: baz }}
  ]

  returns: { foo: baz }
**/
export const getDataForStep = (stepName, steps) => {
  let stepWithData = steps?.filter((s) => s.name == stepName);
  if (stepWithData.length == 0) {
    return null;
  }

  if (stepWithData.length > 1) {
    throw new Error('This should not happen');
  }

  stepWithData = stepWithData[0];
  return stepWithData.data;
};
